module.exports = __webpack_public_path__ + "static/media/story.c69247c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/story.svg
// module id = 138
// module chunks = 0